import { useMemo } from "react";
import { useSelector } from "react-redux";
import { buildIframeParams } from "../utils/iframeParamsUtils";

const useIframeParams = (iframeParams) => {
    const lang = useSelector(state => state.translate.lang);
    const userDetails = useSelector(state => state.auth.userDetails);
    return useMemo(
        () => buildIframeParams(iframeParams),
        [iframeParams, lang, userDetails]
    );
};

export default useIframeParams;
